import { InactiveSegmentContainer } from './RejoinPanel';
import { Button } from '@platform/components';
import { Link } from 'wouter';
import { ROUTES } from '../../routes/consts';

export const IndividualInactivePanel = () => {
  const surveyLink = `/platform${ROUTES.AUTH}${ROUTES.SIGN_UP}${ROUTES.SIGN_UP_PRO_PAUSE}`;
  return (
    <InactiveSegmentContainer>
      <h2 className='text-xl font-bold text-center mb-4'>
        Things are paused while we design what's next
      </h2>
      <p className='text-center mb-4'>
        We're redesigning the experience for individual professionals because we know it can be
        better. We want to design what's next with you.
      </p>
      <div className='text-center'>
        <Button
          variant='primary'
          href={`${surveyLink}#perspective`}
          size='lg'
          additionalClassnames='mb-[16px] w-fit px-16 mx-auto'
        >
          Provide your perspective
        </Button>
        <Link to={`~${surveyLink}`} className='hover:underline text-brand-500'>
          Learn more about what's next
        </Link>
      </div>
    </InactiveSegmentContainer>
  );
};
